import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProgressSpinnerService {
  private loadingCount = 0;
  showProgress = false;

  show(): void {
    this.loadingCount++;
    this.updateProgress();
  }

  hide(): void {
    if (this.loadingCount > 0) {
      this.loadingCount--;
    }
    this.updateProgress();
  }

  private updateProgress(): void {
    this.showProgress = this.loadingCount > 0;
  }
}
